import {Component, inject} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {EventService} from "shared/event.service";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-freemium-premium-confirm-trial-access',
    imports: [
        TranslateModule
    ],
  templateUrl: './freemium-premium-confirm-trial-access.component.html',
  styleUrl: './freemium-premium-confirm-trial-access.component.scss'
})
export class FreemiumPremiumConfirmTrialAccessComponent {
    private eventService = inject(EventService);
    dialogRef = inject(MatDialogRef<FreemiumPremiumConfirmTrialAccessComponent>);

    action() {
        this.dialogRef.close();
    }
}